import React, { Component } from 'react'
import { showSideBar } from "../../../redux/actions/miscActions";
import { connect } from 'react-redux'
import PakketOverview from '../ulits/PakketOverview'

export class Pakketten extends Component {
  
  showNewPakketForm=()=>{
    this.props.showSideBar("newPakketForm");
  }

  render() {
    const { allClientPakketten } = this.props.products
    return (
      <div className="pakketten-pagina">
        <div className="new-form-buttons">
          <button onClick={this.showNewPakketForm} className="small-main-btn">
            Nieuw pakket
          </button>
        </div>
        <PakketOverview pakketten={allClientPakketten} />
      </div>
    )
  }
}


const mapStateToProps=(state)=>({
  products: state.products
})

export default connect(mapStateToProps, {showSideBar})(Pakketten)
